/**
 * What deleting a project asks first, the same wherever it is offered (the project popup, the
 * Structure page). The question a person has is how much goes: only the project. The server
 * refuses while it holds anything (tasks, finished ones included, notes, Context scoped to it),
 * so nothing in it is ever deleted with it. And a project that is simply finished should be
 * archived rather than deleted, so its record survives.
 */
export function deleteProjectQuestion(name: string): string {
  return (
    `Permanently delete the project "${name}"?\n\n` +
    "Only the project goes, never what is in it: while it holds any tasks (finished ones " +
    "too), notes or Context, the delete is refused.\n\n" +
    "If it is finished, archive it instead: it stays on record, with its tasks and their " +
    "history. This cannot be undone."
  );
}
